// Root modal types for dialogs that RootModal loads lazily. Kept apart from the dialog modules so the
// registry and callers can name a dialog without loading its code.
export const DIALOG_TYPE_ACCOUNT_EDIT = 'DIALOG_TYPE_ACCOUNT_EDIT';
export const DIALOG_TYPE_EMAIL_VERIFICATION_DIALOG = 'DIALOG_TYPE_EMAIL_VERIFICATION_DIALOG';
export const DIALOG_TYPE_IDENTITY_VERIFICATION_DIALOG = 'DIALOG_TYPE_IDENTITY_VERIFICATION_DIALOG';
export const DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT = 'DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT';
export const DIALOG_TYPE_LLM_GOAL = 'LLM_GOAL';
export const DIALOG_TYPE_LLM_GOAL_CONTRIBUTE = 'LLM_GOAL_CONTRIBUTE';
export const DIALOG_TYPE_LLM_RECURRING = 'LLM_RECURRING';
export const DIALOG_TYPE_LLM_RULE = 'LLM_RULE';
export const DIALOG_TYPE_LLM_TRANSACTION = 'LLM_TRANSACTION';
export const DIALOG_TYPE_LLM_WATCHLIST = 'LLM_WATCHLIST';
export const DIALOG_TYPE_PHONE_VERIFICATION_DIALOG = 'DIALOG_TYPE_PHONE_VERIFICATION_DIALOG';
export const DIALOG_TYPE_REFUND_EDIT = 'DIALOG_TYPE_REFUND_EDIT';
export const DIALOG_TYPE_REFUND_MATCH = 'DIALOG_TYPE_REFUND_MATCH';
export const DIALOG_TYPE_REVIEW_CATEGORY = 'LLM_CATEGORIZE_TRANSACTIONS';
export const DIALOG_TYPE_SECURITY_EDIT = 'DIALOG_TYPE_SECURITY_EDIT';
